<template>
    <v-container>
        <v-card>

        </v-card>
    </v-container>
</template>

<script>

    export default{
        data(){
            return {
            }
        }
    }
</script>